import React from 'react';
import { Grid, Stack, Card, CardContent } from '@mui/material';
import { DealTypes } from 'api';
import { SelectInputControlled } from 'components';
import { ATTRIBUTION_MODEL_OPTIONS } from 'constants/common';
import { AttributionModelEnum } from 'types/common';
import { useStoreContext } from 'store';
import { setStoreState } from 'store/actions';
import DealComparisonCard from './DealComparisonCard';
import BudgetComparisonCard from './BudgetComparisonCard';
import BrandEconomics from './BrandEconomics';
import MetricsChart from './MetricsChart';
import PrimaryMetrics from './PrimaryMetrics';
import ProductsTable from './ProductsTable';
import InfoCardsStack from './InfoCardsStack';

interface Props {
  inline?: boolean;
  deal: DealTypes.ItemDataExtended;
}

const PerformanceTab = (props: Props): JSX.Element | null => {
  const { deal, inline } = props;
  const {
    state: { attributionModel },
    dispatch,
  } = useStoreContext();

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <SelectInputControlled
                  name="attributionModel"
                  label="Attribution Model"
                  options={ATTRIBUTION_MODEL_OPTIONS}
                  value={attributionModel}
                  onChange={(event) =>
                    dispatch(
                      setStoreState({
                        attributionModel: event.target
                          .value as AttributionModelEnum,
                      }),
                    )
                  }
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12}>
        <PrimaryMetrics
          deal={deal}
          inline={inline}
          attributionModel={attributionModel}
        />
      </Grid>
      <Grid item xs={12} md={inline ? 12 : 6}>
        <InfoCardsStack deal={deal} attributionModel={attributionModel} />
      </Grid>
      <Grid item xs={12} md={inline ? 12 : 6}>
        <MetricsChart deal={deal} />
      </Grid>
      <Grid item xs={12} md={inline ? 12 : 6}>
        <Stack rowGap={3}>
          <BudgetComparisonCard deal={deal} />
          <DealComparisonCard deal={deal} />
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <BrandEconomics deal={deal} />
      </Grid>
      <Grid item xs={12}>
        <ProductsTable deal={deal} />
      </Grid>
    </Grid>
  );
};

export default PerformanceTab;
